import { ContentBoxInterface } from 'common/types/entities/ContentBoxInterface'

export const getContentBoxFontProperties = (entity: ContentBoxInterface) => {
  const fontProperties = entity.header.fontFamily
    ? [
        {
          fontFamily: entity.header.fontFamily,
          fontStyle: entity.header.fontStyle,
          fontWeight: entity.header.fontWeight,
        },
      ]
    : []

  if (entity.header.mobileFontFamily) {
    fontProperties.push({
      fontFamily: entity.header.mobileFontFamily,
      fontStyle: entity.header.mobileFontStyle,
      fontWeight: entity.header.mobileFontWeight,
    })
  }

  return fontProperties
}

export function getContentBoxCustomFontProperties(entity: ContentBoxInterface) {
  const customFonts = []

  if (entity.header.fontFileId && entity.header.fontFamily) {
    customFonts.push({
      fontFamily: entity.header.fontFamily,
      fontFileId: entity.header.fontFileId,
    })
  }

  if (entity.header.mobileFontFileId && entity.header.mobileFontFamily) {
    customFonts.push({
      fontFamily: entity.header.mobileFontFamily,
      fontFileId: entity.header.mobileFontFileId,
    })
  }
  return customFonts
}
